import React, { useState } from "react";
import styles from "./styles.module.scss";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { AlertBox } from "../../../../shared/AlertBox/AlertBox";
import { Textarea } from "../../../../shared/Textarea/Textarea";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";
import { Button } from "../../../../shared/Button/Button";
import { isNullish } from "../../../../utilities/general";

/**
 * @param {{
 *   cannotSendReason?: string;
 *   messageCharLimit?: number;
 *   isLoading?: boolean;
 *   isSending?: boolean;
 *   onSend: (message: string) => void;
 * }} param0
 */
export const Footer = ({
  cannotSendReason,
  messageCharLimit,
  isLoading,
  isSending,
  onSend,
}) => {
  const { tCommon: t } = useAppTranslation.Common();
  const [message, setMessage] = useState("");

  return (
    <div className={styles.root}>
      {cannotSendReason ? (
        <AlertBox size="small">{cannotSendReason}</AlertBox>
      ) : (
        <>
          <div className={styles.controls}>
            <Textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder={t("chat.send.placeholder")}
              maxLength={messageCharLimit}
              maxRows={5}
              className={styles.input}
              isDisabled={isLoading}
            />
            <Button
              className={styles.send}
              onClick={() => onSend(message).then(() => setMessage(""))}
              isDisabled={isSending || isLoading || !message.trim()}
              leftAdornment={
                isSending ? (
                  <CircularProgress size="tiny" color="white" />
                ) : undefined
              }
            >
              {t("chat.send.submit")}
            </Button>
          </div>
          {!isNullish(messageCharLimit) && (
            <div className={styles.charLimit}>
              {message.length} / {messageCharLimit}
            </div>
          )}
        </>
      )}
    </div>
  );
};
